import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import ROUTES from "../../configs/routesConfig";
import { updateUserData } from "../../acions/auth";
import { Loader } from "../../components/Loader";
import { ProfilesService } from "../../services/profiles";
import { useAppDispatch } from "../../store";
import { useNavigate } from "react-router-dom";
import { deleteUserData } from "../../acions/auth";
import { LogoutModal } from "./LogoutModal";
import { setPermissions } from "../../acions/actionsCreators/permissions";
import { useVisitTracker } from "../hooks/analitics/useVisitTracker";
import { useServerSideEvents } from "../hooks/useServerSideEvents";

type PrivateRouteContainerProps = {
  userData: any;
};

export const PrivateRouteContainer = ({ userData }: PrivateRouteContainerProps) => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState<boolean>(true);

  useVisitTracker();

  useServerSideEvents();

  useEffect(() => {
    if (userData.firstName && userData.lastName) {
      setIsLoading(false);
    } else {
      setIsLoading(true);

      ProfilesService.fetchUser()
        .then((res) => {
          dispatch(
            updateUserData({
              firstName: res.firstName,
              lastName: res.lastName
            })
          );
          dispatch(setPermissions(res.permissions));
          setIsLoading(false);
        })
        .catch((e: any) => {
          if (e.response && e.response.status !== 405) {
            Promise.resolve(dispatch(deleteUserData())).then(() => {
              navigate(ROUTES.LOGIN);
              setIsLoading(false);
            });
          }
        });
    }
  }, [dispatch, navigate, userData]);

  return isLoading ? (
    <Loader fontSize="128px" />
  ) : (
    <>
      <LogoutModal />
      <Outlet />
    </>
  );
};
